import type {Agent} from 'services/agent/types';
import type {SearchSchemas} from 'api/search.dto.generated';
import {mapAgentDto} from 'services/agent';
import type {SearchResult, SearchResultDto} from '../types';
import {mapAgentDocumentToAgentDto} from './mapAgentDocumentToAgentDto';
import {mapHighlight} from './mapHighlight';

export const mapAgentHits = (
  dto: SearchResultDto<SearchSchemas.AgentDocument>,
): SearchResult<Agent> => {
  return {
    hits: dto?.hits.hits.map(h =>
      mapAgentDto(mapAgentDocumentToAgentDto(h._source)),
    ),
    highlights: dto?.hits.hits.map(h => mapHighlight(h.highlight)).flat(1),
    total: dto.hits.total.value,
  };
};
